import type { TPreparationStatus } from 'src/store/well-pad-preparation/types';

export const getRSEReadinessColor = (rseValue: TPreparationStatus): string => {
  switch (rseValue) {
    case 'ready': {
      return 'var(--green-color)';
    }
    case 'inProcess': {
      return 'var(--orange-color)';
    }
    case 'notReady': {
      return 'var(--bright-red)';
    }
    default: {
      return 'transparent';
    }
  }
};
